export default {
  computed: {
    iFrameMode() {
      return this.$route.query.iframe === 'true';
    }
  }
};
